import { EuiFlexItem } from '@elastic/eui';
import React, { useEffect, useState } from 'react';
import ComboEjerciciosContainer from '../../../components/Selectores/Ejercicios/container';


export const FiltroCostos = (props) =>{

  let {onFilter, refresh, setRefresh} = props;

  let [ejercicio, setEjercicio] = useState(undefined);

  useEffect(()=>{if(ejercicio !== undefined){onFilter && onFilter(ejercicio)}},[ejercicio])

return (
  <EuiFlexItem>
    <ComboEjerciciosContainer grow={false} refresh={refresh} setRefresh={setRefresh} valueOfSelected={ejercicio} onChange={value => setEjercicio(value)}/>
  </EuiFlexItem>
)
}